<template>
    <div class="TTL-page TTL-page-right">
        <el-pagination
            @current-change="changepage"
            @size-change="changesize"
            v-model:current-page="pagep"
            v-model:page-size="pagerollpage"
            :page-sizes="[20,40,60,100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagerow"
        />
    </div>
</template>

<script>
export default {
  props: ['row','p','rollpage'],
  data() {
      return {
          pagerow: this.row && this.row > 0 ? this.row : 0,
          pagep: this.p && this.p > 0 ? this.p : 1,
          pagerollpage: this.rollpage && this.rollpage > 0 ? this.rollpage : 10,
      }
  },

  watch: {
      row(val) {
          this.pagerow=val;
      },
      p(val) {
          this.pagep=val;
      },
      rollpage(val) {
          this.pagerollpage=val;
      },

  },

  mounted() {
      
  },

  methods: {

      /** 修改页数 **/
      changepage() {
          this.$emit('finish',{type:'changep',p:this.pagep,rollpage:this.pagerollpage});
      },


      /** 修改数据，变更 **/
      changesize() {
          this.$emit('finish',{type:'changerollpage',p:this.pagep,rollpage:this.pagerollpage});
      },

  }

}
</script>

<style scoped>

</style>